import { InsightMetric } from '@repo/types';
import c from 'classnames';
import { Badge } from 'components';
import styles from './MetricsCategories.module.css';

type CategoryTagsProps = {
  submetric: InsightMetric;
  topPriorityRanks: Map<number, number>;
  className?: string;
};

export default function CategoryTags({
  submetric,
  topPriorityRanks,
  className,
}: CategoryTagsProps) {
  const priorityRank = topPriorityRanks.get(submetric.sample_health_id);

  return priorityRank || !!submetric.gut_vaginal_health.beta ? (
    <div className={c(styles.tags, className)}>
      {!!submetric.gut_vaginal_health.beta && (
        <Badge title='BETA' state='new' size='sm' />
      )}
      {!!priorityRank && (
        <Badge title={`Priority #${priorityRank}`} state='bad' size='sm' />
      )}
    </div>
  ) : null;
}
